/**
 * Prototype's group-label tag icon, redrawn locally rather than added to the kai-shiki
 * design-system package (separately published — adding it there would need a version bump
 * before it could be used here). Built to the same shape as kai-shiki's own icons (see
 * `EditIcon` in kai-shiki's `GeneralIcons.tsx`): `color`/`size` props, `currentColor` default
 * so it inherits whatever color/hover state its parent button sets.
 */
export const TagIcon = ({
  color = 'currentColor',
  size = 24,
  ...props
}: {
  color?: string;
  size?: number;
} & Record<string, unknown>) => (
  <svg
    width={size}
    height={size}
    viewBox={'0 0 24 24'}
    fill={'none'}
    stroke={color}
    strokeWidth={1.6}
    strokeLinejoin={'round'}
    strokeLinecap={'round'}
    aria-hidden
    {...props}
  >
    <path d={'M22.5 1.5H13L0.5 14L10 23.5L22.5 11V1.5Z'} />
    <path d={'M20.501 3.5H17.501V6.5H20.501V3.5Z'} />
  </svg>
);
